import { gsap } from 'gsap';

export default class Accordion {
	constructor(container) {
		this.panels = container.querySelectorAll('[data-faq-panel]');
		this.panels.forEach((panel) => {
			this.openFAQ(panel);
		});
	}

	openFAQ(el) {
		el.addEventListener('click', () => {
			el.classList.toggle('is-open');
			const panelAnswer = el.querySelector('[data-faq-answer]');
			if (panelAnswer.style.maxHeight) {
				panelAnswer.style.maxHeight = null;
				panelAnswer.style.marginTop = 0;
			} else {
				panelAnswer.style.maxHeight = panelAnswer.scrollHeight + 'px';
				panelAnswer.style.marginTop = '2.4rem';
			}
		});
	}
}
